/* eslint-disable react/jsx-no-comment-textnodes */

// import './index.css';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideLoader } from '../../../actions/app-actions-types';
import EventEmitter from '../../../utilities/EventEmitter';
import useGame from '../../../utilities/hooks/game';

import { getRouteObjByGame, isSmartPhone } from '../../../utilities/helper';
import { useLink } from 'react-router-stack';

import constants from '../../../constants';
import ContestListTabMWeb from './index_mWeb';
import ContestListTabWeb from './index_web';

const ContestListTab = () => {
  const { contestListByCategory: fantasyCricketContestListByCategory } = useSelector(
    (state: any) => state.fantasy_cricket
  );
  const { contestListByCategory: fantasyFootballContestListByCategory } = useSelector(
    (state: any) => state.fantasy_football
  );
  const navigate = useLink();
  const {
    gameType,
    item: matchItem,
    myTeamList = [],

    contestCategories = {},
    fantasyMatchClick,
    setAllContestList
  } = useGame();
  const [contestCategoryList, setContestCategoryList] = useState([] as any[]);

  const [error, setError] = useState(false);
  const [contestFilterVisible, setContestFilterVisible] = useState(false);
  const [contestShare, setContestShare] = useState(false);
  const [contestLink] = useState('');
  const [contestTitle] = useState('');

  const { status: matchStatus = '', gameState = 0, matchDelayed = false } = matchItem;
  const totalTeamsCount = myTeamList[matchItem._id]?.length;

  const dispatch = useDispatch();

  useEffect(() => {
    getAllContestListAPI();

    window.addEventListener('popstate', onClickBrowserBack);
    EventEmitter.on('updateContestsList', updateAllContest);
    return () => {
      EventEmitter.off('updateContestsList', updateAllContest);
      window.removeEventListener('popstate', onClickBrowserBack);
    };
  }, []);

  const onClickBrowserBack = () => {
    setContestFilterVisible(false);
  };

  const updateAllContest = () => {
    getAllContestListAPI();
  };

  const getAllContestListAPI = async () => {
    let result: any = [];
    if (gameType === constants.GameType.FANTASY_CRICKET) {
      result = fantasyCricketContestListByCategory[matchItem['_id']];
    }
    if (gameType === constants.GameType.FANTASY_FOOTBALL) {
      result = fantasyFootballContestListByCategory[matchItem['_id']];
    }
    dispatch(hideLoader());
    if (!error) {
      try {
        let resultList: any[] = [];
        result.forEach(function (item: any) {
          const { contests = [], _id = '' } = item;
          contests.sort(function (x: any, y: any) {
            return y.winningsAmount - x.winningsAmount;
          });
          const list = contests;
          const contestCategory = contestCategories[_id];
          resultList.push({
            header: {
              ...contestCategory,
              contestCount: contests.length
            },
            data: list
          });
        });
        resultList.sort(function (x, y) {
          const xPriority = x?.header?.priority || 0;
          const yPriority = y?.header?.priority || 0;
          return xPriority - yPriority;
        });
        setContestCategoryList(resultList);

        let contestCategoryData: any = [];
        resultList.forEach((elem: any) => {
          contestCategoryData.push({ ...elem.header, header: true });
          contestCategoryData = [...contestCategoryData, ...elem.data];
        });
        setError(false);
      } catch (error) {
        console.log(error);
      }
    } else {
      setError(true);
    }
  };

  const showAllContest = (categoryId: any, title: any) => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          categoryId,
          title
        }
      })
    );
    let allContestList: any;
    if (gameType === constants.GameType.FANTASY_CRICKET) {
      allContestList = fantasyCricketContestListByCategory[matchItem['_id']].find(
        (item: any) => item._id === categoryId
      );
    }
    if (gameType === constants.GameType.FANTASY_FOOTBALL) {
      allContestList = fantasyFootballContestListByCategory[matchItem['_id']].find(
        (item: any) => item._id === categoryId
      );
    }

    dispatch(setAllContestList(allContestList['contests']));
    navigate.push(getRouteObjByGame(gameType)['all_contest']);
  };

  const onPressShare = async () => {};

  const onPressCard = (contest: any) => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          contest
        }
      })
    );

    navigate.push(getRouteObjByGame(gameType)['contest_details']);
  };

  const setAllContestData = () => {
    let contest: any = [];
    if (gameType === constants.GameType.FANTASY_CRICKET) {
      fantasyCricketContestListByCategory[matchItem['_id']].forEach((item: any) => {
        for (let contestItem of item.contests) {
          contest.push(contestItem);
        }
      });
    }
    if (gameType === constants.GameType.FANTASY_FOOTBALL) {
      fantasyFootballContestListByCategory[matchItem['_id']].forEach((item: any) => {
        for (let contestItem of item.contests) {
          contest.push(contestItem);
        }
      });
    }
    dispatch(setAllContestList([...contest]));
  };

  const onApplyFilter = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          categoryId: '',
          title: 'All Contest',
          isAppliedFilter: true
        }
      })
    );
    if (gameType === constants.GameType.FANTASY_CRICKET) {
      const allContestList = fantasyCricketContestListByCategory[matchItem['_id']]
        .map((item: any) => item.contests)
        .flat();
      dispatch(setAllContestList(allContestList));
    }
    if (gameType === constants.GameType.FANTASY_FOOTBALL) {
      const allContestList = fantasyFootballContestListByCategory[matchItem['_id']]
        .map((item: any) => item.contests)
        .flat();
      dispatch(setAllContestList(allContestList));
    }

    setContestFilterVisible(false);

    navigate.push(getRouteObjByGame(gameType)['all_contest']);
  };

  const onPressEntryFee = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          categoryId: '',
          title: 'All Contest',
          defaultSort: 'Entry'
        }
      })
    );
    setAllContestData();
    navigate.push(getRouteObjByGame(gameType)['all_contest']);
  };

  const onPressPrizePool = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          categoryId: '',
          title: 'All Contest',
          defaultSort: 'PrizePool'
        }
      })
    );
    setAllContestData();
    navigate.push(getRouteObjByGame(gameType)['all_contest']);
  };

  const onPressSpots = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          categoryId: '',
          title: 'All Contest',
          defaultSort: 'Spots'
        }
      })
    );
    setAllContestData();

    navigate.push(getRouteObjByGame(gameType)['all_contest']);
  };

  const onPressWinners = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          categoryId: '',
          title: 'All Contest',
          defaultSort: 'Winner'
        }
      })
    );
    setAllContestData();

    navigate.push(getRouteObjByGame(gameType)['all_contest']);
  };

  const onClearFilter = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          categoryId: '',
          title: 'All Contest',
          defaultSort: ''
        }
      })
    );
    setAllContestData();
    setContestFilterVisible(false);
  };

  const onPressFilter = () => {
    setContestFilterVisible(true);
  };

  const onPressFilterDismiss = () => {
    setContestFilterVisible(false);
  };

  const onPressShareModalDismiss = () => {
    setContestShare(false);
  };

  return (
    <React.Fragment>
      {isSmartPhone ? (
        <ContestListTabMWeb
          onPressFilter={onPressFilter}
          onPressEntryFee={onPressEntryFee}
          onPressPrizePool={onPressPrizePool}
          onPressSpots={onPressSpots}
          onPressWinner={onPressWinners}
          onPressCard={onPressCard}
          onPressShare={onPressShare}
          contestCategoryList={contestCategoryList}
          matchStatus={matchStatus}
          gameState={gameState}
          matchItem={matchItem}
          matchDelayed={matchDelayed}
          gameType={gameType}
          onApplyFilter={onApplyFilter}
          onClearFilter={onClearFilter}
          contestFilterVisible={contestFilterVisible}
          onPressFilterDismiss={onPressFilterDismiss}
          contestLink={contestLink}
          contestTitle={contestTitle}
          contestShare={contestShare}
          onPressShareModalDismiss={onPressShareModalDismiss}
          showAllContest={showAllContest}
          totalTeamsCount={totalTeamsCount}
        />
      ) : (
        <ContestListTabWeb
          onPressFilter={onPressFilter}
          onPressEntryFee={onPressEntryFee}
          onPressPrizePool={onPressPrizePool}
          onPressSpots={onPressSpots}
          onPressWinner={onPressWinners}
          onPressCard={onPressCard}
          onPressShare={onPressShare}
          contestCategoryList={contestCategoryList}
          matchStatus={matchStatus}
          gameState={gameState}
          totalTeamsCount={totalTeamsCount}
          matchItem={matchItem}
          matchDelayed={matchDelayed}
          gameType={gameType}
          onApplyFilter={onApplyFilter}
          onClearFilter={onClearFilter}
          contestFilterVisible={contestFilterVisible}
          onPressFilterDismiss={onPressFilterDismiss}
          contestLink={contestLink}
          contestTitle={contestTitle}
          contestShare={contestShare}
          onPressShareModalDismiss={onPressShareModalDismiss}
          showAllContest={showAllContest}
        />
      )}
    </React.Fragment>
  );
};

export default ContestListTab;
